<script type="text/jsx">
import {
  StyledSocialsList,
  StyledSocialsItem,
  StyledSocialsLink
} from './StyledSocials'

export default {
  name: 'Socials',
  render () {
    return (
      <StyledSocialsList>
        <StyledSocialsItem>
          <StyledSocialsLink href={this.$t('base.viber.link')} domPropsInnerHTML={this.$t('base.viber.icon')} />
        </StyledSocialsItem>
        <StyledSocialsItem>
          <StyledSocialsLink href={this.$t('base.telegram.link')} target="_blank" domPropsInnerHTML={this.$t('base.telegram.icon')} />
        </StyledSocialsItem>
      </StyledSocialsList>
    )
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Socials/Socials.vue